export default {
  billBlacklist: [],
}
